import { useSelector } from "react-redux";
import { selectIsQuizFeedbackOpen } from "../../app/slices/GlobalSlice";
import QuizFeedbackColumn from "./QuizFeedbackColumn";
import {
  QUIZ_FEEDBACK_SPLIT_COLUMN_WIDTH,
  QUIZ_FEEDBACK_TRANSITION,
} from "./QuizFeedbackLayout";

// persistent wrapper that slides the quiz feedback column open and closed
// (0 <-> widthPx) with a CSS width transition
export default function QuizFeedbackCollapsableColumn(props: {
  widthPx?: number;
}) {
  const { widthPx = QUIZ_FEEDBACK_SPLIT_COLUMN_WIDTH } = props;
  const isOpen = useSelector(selectIsQuizFeedbackOpen);
  const width = isOpen ? widthPx : 0;

  return (
    <div
      className="h-full overflow-hidden"
      style={{
        width,
        minWidth: width,
        transition: QUIZ_FEEDBACK_TRANSITION,
      }}
      data-testid="quiz-feedback-collapsable-column"
    >
      {/* fixed inner width so the content doesn't reflow while clipping */}
      <div className="h-full" style={{ width: widthPx }}>
        <QuizFeedbackColumn />
      </div>
    </div>
  );
}
